export default __webpack_public_path__ + "b31e6dd0fc9ef8414f36d9f80566146f.png";